import React from 'react'

const UserScoreRecommendation = ({ array_suggestions }) => {
    if (!array_suggestions || array_suggestions.length === 0) return null

    return (
        <div className="containerLabel gap-10 no-flex">
            <span className="label green">Acciones Sugeridas:</span>
            {
                array_suggestions.map((suggestion, index) => (
                    <div key={`suggestion-${index}`} className={`containerLabel ${index === 0 ? 'gap-16' : 'gap-10'}`} >
                        <span className="label single-line">Acción {index + 1}:</span>
                        <div className="label-status mayus">{suggestion}</div>
                    </div>
                ))
            }
        </div>
    )
}

export default UserScoreRecommendation